var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-requirements"},_vm._l((_vm.requirements),function(requirement,index){return _c('div',{key:index,staticClass:"requirement-item"},[_c('v-icon',{attrs:{"color":requirement.valid
          ? _vm.$config.dados.successColor
          : _vm.$config.dados.errorColor,"small":""}},[_vm._v(" "+_vm._s(requirement.valid ? "mdi-check" : "mdi-close")+" ")]),_c('span',{style:({
        color: requirement.valid
          ? _vm.$config.dados.successColor
          : _vm.$config.dados.errorColor,
      })},[_vm._v(_vm._s(requirement.message))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }